import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaCloudRain } from "react-icons/fa";

import FarmMapPluviometryDemo from "./FarmMapPluviometryDemo";

import "./FarmMapTrackHeadings.css";
import "./FarmMapPluviometry.css";

function FarmRainHistoryDemo() {
  const { farm_id: farmId } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Agriconnected - Demonstração de Chuva";
  }, []);

  return (
    <div className="farm-map-page">
      <div className="farm-map-page__header">
        <h1>
          <FaCloudRain style={{ marginRight: 8 }} />
          {t("Demonstração — Histórico de Chuva")}
        </h1>
      </div>
      <FarmMapPluviometryDemo farmId={farmId} />
    </div>
  );
}

export default FarmRainHistoryDemo;
